import React, { useState } from 'react';
import {
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  Flex,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { observer } from 'mobx-react';

/** Section header matching App Icon Maker style */
const GroupHeader = ({ label }) => {
  const lineColor = useColorModeValue('gray.200', 'gray.700');
  const textColor = useColorModeValue('gray.600', 'gray.300');
  return (
    <Flex align="center" gap={3} mb={2}>
      <Text fontSize="sm" fontWeight="semibold" color={textColor} whiteSpace="nowrap">
        {label}
      </Text>
      <Box flex={1} h="1px" bg={lineColor} />
    </Flex>
  );
};

const SelectionTreeView = observer(({ store }) => {
  const [orientation, setOrientation] = useState('portrait');
  const mutedColor = useColorModeValue('gray.500', 'gray.400');

  const handleToggle = (newOrientation) => {
    if (newOrientation !== orientation) {
      setOrientation(newOrientation);
      store.clearSelections();
    }
  };

  const groupedSelections = store.groupedSelectionsByOrientation(orientation);

  return (
    <VStack align="stretch" spacing={4}>
      {/* Portrait / Landscape toggle */}
      <ButtonGroup isAttached variant="outline" size="sm">
        <Button
          colorScheme="blue"
          variant={orientation === 'portrait' ? 'solid' : 'outline'}
          onClick={() => handleToggle('portrait')}
        >
          Portrait
        </Button>
        <Button
          colorScheme="blue"
          variant={orientation === 'landscape' ? 'solid' : 'outline'}
          onClick={() => handleToggle('landscape')}
        >
          Landscape
        </Button>
      </ButtonGroup>

      {/* Grouped checkboxes */}
      {Object.entries(groupedSelections).map(([storeName, devices]) => (
        <Box key={storeName}>
          <GroupHeader label={storeName} />
          {Object.entries(devices).map(([device, models]) => (
            <Box key={device} mb={2}>
              <Text fontSize="xs" fontWeight="semibold" color={mutedColor} mb={1} pl={1}>
                {device}
              </Text>
              <VStack align="stretch" spacing={1} pl={2}>
                {models.map((model, index) => (
                  <Checkbox
                    key={`${model.uniqueIdentifier}-${index}`}
                    isChecked={model.selected}
                    onChange={() => store.toggleSelection(model.uniqueIdentifier)}
                    colorScheme="blue"
                    size="md"
                  >
                    <Flex align="baseline" gap={1.5}>
                      <Text fontSize="sm" fontWeight="medium">{model.model}</Text>
                      <Text fontSize="xs" color={mutedColor}>— {model.resolution}</Text>
                    </Flex>
                  </Checkbox>
                ))}
              </VStack>
            </Box>
          ))}
        </Box>
      ))}
    </VStack>
  );
});

export default SelectionTreeView;
